<template>
  <main id="home" class="site-main">
    <div class="grid-x grid-padding-x">
      <div class="cell">
        <div class="grid-x grid-padding-x">
          <div class="welcome cell large-auto">
            <div class="welcome__title">{{ welcomeMessage }},
              {{ shop ? shop.name : '' }}
            </div>

            <div class="welcome__content">
              <p>Welcome to My Sales Reps!</p>
            </div>
          </div>

          <div class="stats cell large-shrink">
            <div>
              <div class="grid-x">
                <div class="cell auto label warning">
                  <div class="label__heading">Due</div>
                  <div class="label__content">{{ commissionDue }}</div>
                </div>

                <div class="cell auto label success">
                  <div class="label__heading">Paid</div>
                  <div class="label__content">{{ commissionPaid }}</div>
                </div>

                <div class="cell auto label">
                  <div class="label__heading">Earned</div>
                  <div class="label__content">{{ commissionEarned }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid-x grid-margin-x">
          <div class="panel cell large-8 xlarge-6 small-order-1 show-for-large">
            <chart></chart>
          </div>

          <div
            class="panel cell small-auto medium-6 xlarge-3 small-order-3 medium-order-3 xlarge-2"
          >
            <div class="panel__header">
              <h3 class="panel__title">Recent Payouts</h3>
            </div>

            <recentPayouts></recentPayouts>
          </div>

          <div
            class="panel cell small-auto large-4 xlarge-3 small-order-2 xlarge-order-3">
            <div class="panel__header">
              <div class="grid-x grid-padding-x">
                <div class="cell auto">
                  <h3 class="panel__title">Notifications</h3>
                </div>
              </div>
            </div>

            <div class="panel__content">
              <announcements></announcements>
            </div>
          </div>

          <div
            class="panel cell medium-6 xlarge-4 small-order-2 medium-order-4">
            <div class="panel__header">
              <h3 class="panel__title">Commissions Due</h3>
            </div>

            <div class="panel__content">
              <commissionsDue></commissionsDue>
            </div>
          </div>

          <div class="panel cell xlarge-8 small-order-5">
            <topEarners></topEarners>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'
import chart from '@/pages/vendors/sections/chart'
import recentPayouts from '@/pages/vendors/sections/recentPayouts'
import commissionsDue from '@/pages/vendors/sections/commissionsDue'
import topEarners from '@/pages/vendors/sections/topEarners'
import announcements from '@/pages/vendors/sections/announcements'

export default {
  name: 'home',
  mixins: [client, utils],
  components: {
    chart,
    recentPayouts,
    commissionsDue,
    topEarners,
    announcements
  },
  data: function () {
    return {
      welcomeMessage: 'Good Morning',
      orderCount: 0,
      commissionDue: 0,
      commissionPaid: 0,
      commissionEarned: 0,
      showTutorial: false,
      showTutorial2: false
    }
  },
  methods: {
    getOrders: function () {
      this.request('get', '/orders/', {
        date_range: this.dateRange
      }).then((response) => {
        this.orderCount = response.count
      })
    },
    getTotals: function () {
      this.request('get', '/vendors/commission-totals/combined/').then(
        (response) => {
          this.commissionDue = this.formatMoney(response.commission_due)
          this.commissionPaid = this.formatMoney(response.commission_paid)
          this.commissionEarned = this.formatMoney(response.commission_earned)
        }
      )
    }
  },
  computed: {
    shop () {
      return this.$store.state.shop
    },
    meta () {
      return this.$store.state.metas
    }
  },
  created () {
    this.commissionDue = this.formatMoney(0)
    this.commissionPaid = this.formatMoney(0)
    this.commissionEarned = this.formatMoney(0)

    this.getOrders()
    this.getTotals()

    let date = new Date()
    let hours = date.getHours()
    this.welcomeMessage = hours < 12 ? 'Good Morning' : hours < 18 ? 'Good Afternoon' : 'Good Evening'
  }
}
</script>

<style lang="scss">
@import "../../styles/mixins";
@import "../../styles/variables";

.welcome {
  &__title {
    font-size: 24px;
    font-weight: 900;
  }

  &__content {
    /*max-width: 600px;*/
  }
}

.stats {
  padding-top: 10px;

  .grid-x {
    margin: 0 -2px;
  }

  .cell {
    flex: none;
  }

  .label {
    margin: 0 2px 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: left;
    width: 180px;

    &__heading {
      font-size: 16px;
      margin-bottom: 5px;
    }

    &__content {
      font-size: 18px;
      font-weight: 700;
    }
  }
}

@media (min-width: 641px) {
  .stats {
    padding-top: 0;

    .label {

      &__heading {
        font-size: 18px;
        margin-bottom: 5px;
      }

      &__content {
        font-size: 24px;
        font-weight: 700;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/salesreps/home.vue